import React from 'react';
import { Route } from 'react-router-dom';
import Feed from './index';

export default <Route path="/homepage/feed" component={Feed} />;
